import { Button, Center, Group, Loader, MultiSelect, Pagination, Stack, Text } from '@mantine/core';
import { useVendorAPI } from 'api/useVendorAPI';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import VendorCard from './VendorCard';
import { useConfigData } from 'hooks/useConfigData';

const DashboardVendors = () => {

    const { useGetAllVendor } = useVendorAPI()
    const { vendorTags } = useConfigData()

    const [filters, setFilters] = useState<any[]>([]);
    const [tagFilter, setTagFilter] = useState<string[]>([])
    const [total, setTotal] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)

    const tags = useMemo(() => {
        if (!!vendorTags) {
            return vendorTags.map((t: string) => ({
                value: t,
                label: t
            }))
        }
        return []
    }, [vendorTags])

    // const filters = useMemo(() => {
    //     if (tagFilter.length > 0) {

    //         const tags = tagFilter.map((v: string) => ({
    //             tags: {
    //                 $contains: [v],
    //             },
    //         }))

    //         return tags
    //     }
    // }, [tagFilter])

    const { data, error, isLoading, refetch } = useGetAllVendor({
        filters,
        pagination: {
            page: currentPage,
            pageSize: 10
        }
    })

    useEffect(() => {
        refetch()
    }, []);

    const handleFilterChange = useCallback(() => {
        const tags = tagFilter.map((v: string) => ({
            tags: {
                $contains: [v],
            },
        }))
        setCurrentPage(1)
        setFilters(tags);
        refetch();
    }, [tagFilter]);

    const results = useMemo(() => {
        let result = data as any
        if (!!data && !!result.data && !isLoading) {
            setTotal(result.meta.pagination.pageCount)
            setCurrentPage(result.meta.pagination.page)
            return result.data
        }

        return []
    }, [data, isLoading, filters])

    return (
        <Stack sx={{ position: "relative" }} px={16}>
            <Text fz={32} fw={600}>
                Browse Vendors
            </Text>
            <Group align='flex-end'>
                <MultiSelect
                    data={tags}
                    label="Filter by tags"
                    placeholder="Pick tags to filter vendors by"
                    value={tagFilter}
                    onChange={(e) => setTagFilter(e)}
                    sx={{ flex: 1 }}
                />
                <Button onClick={() => handleFilterChange()}>Filter</Button>
            </Group>
            {!!isLoading && (
                <Center p={24}>
                    <Loader />
                </Center>
            )}
            {!!results && results.length > 0 && results.map((d: any) => (
                <VendorCard
                    data={d}
                />
            ))}
            {results == 0 && (
                <Text align='center' fz="24"> No Results!</Text>
            )}
            <Group sx={{ width: '100%', justifyContent: 'center' }}>
                <Pagination total={total} onChange={setCurrentPage} />
            </Group>
        </Stack>
    );
};

export default DashboardVendors;